
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g3m_45aqDnd_45pbMtV4Bk_NdSZj17ipUNwrwRVrvDtzHE54Meta } from "/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexgwegR51n_45F8_45ykjtiPHMTRGAe8eaheKEOJO3YCOlWuoMeta } from "/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchcW3Q2R7YmY4f938gOo34WZB8_45YhRgmAiAaPUhl8o47cMeta } from "/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexe3GzDsXy0AxmGe7tIQtZ8mcONNidB8AEWI00g_45ARTfEMeta } from "/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93BZF2gi1DUSg0rla_45x_45UGWb_Enj3nhhcObSYKTHcQgw4Meta } from "/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexcgiCE9zfa88irez_AvUoaccKy_45ipZC6HAag0NQx4gioMeta } from "/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93OGXLEftpYff7A0UrQXT2qby_45iTA_45MLzuNmJrn715lzwMeta } from "/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexr_45l4P7czjCvQQ_45d9en8eKCE2k7TzusAke0H14isxlH8Meta } from "/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_930HeWDQla1f1OI2VPFM3U2o7X94EpOdkzz82TVa3p0pMMeta } from "/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexM6F46qC4F5y9sLB_45vyFkHmQGh_BJYFayM1Arp7DmLZEMeta } from "/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexuDk_45rcQ1eIkk_mUHR406n97yPdlDLzEPsuQQ3yUZ0hwMeta } from "/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexcgiCE9zfa88irez_AvUoaccKy_45ipZC6HAag0NQx4gioMeta || {},
    component: () => import("/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexr_45l4P7czjCvQQ_45d9en8eKCE2k7TzusAke0H14isxlH8Meta || {},
    component: () => import("/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexM6F46qC4F5y9sLB_45vyFkHmQGh_BJYFayM1Arp7DmLZEMeta || {},
    component: () => import("/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexuDk_45rcQ1eIkk_mUHR406n97yPdlDLzEPsuQQ3yUZ0hwMeta || {},
    component: () => import("/codebuild/output/src1551069391/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]